import React from 'react'
import { Link } from 'react-router-dom';
import { PencilIcon } from 'react-open-iconic-svg';

import { pagingPropTypes } from 'services/constants';
import { searchStringToParams, 
         objToQueryString }           from 'services/utils';
import RemoveButton        from 'components/RemoveButton';
import PaginatingWithInfo  from 'components/PaginatingWithInfo';

function ItemComponent({ item, collectionName, onRemove }) {
  function removeItem() {
    onRemove(item);
  }
  return (
    <div id={item.id} className="row border rounded pt-1 pb-1 mb-1">
      <Link to={`/${collectionName}/${item.id}`} className="col-1" title="редактировать">
        <PencilIcon className="icon" viewBox="0 0 8 8" alt="редактировать" />
      </Link>
      <div className="col-11 col-md-8">
        <h5>{item.name || item.title}</h5>
        <RemoveButton className="btn-sm ms-2 float-end" remove={removeItem} />
      </div>
    </div>
  );
}


export default class AbstractSearchableList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      paging: {
        total: 0,
        page: 1,
        perPage: 20,
      },
      loading: false,
      busyItems: [],
      search: {},
    };
    this.itemClass = null;
    this.itemName = 'item';
    this.collectionName = 'items';
    this.collectionNameHuman = 'запись';
    this.Item = ItemComponent;
    this.SearchForm = null;
    this.searchStatePropTypes = {};
  }

  componentDidMount() {
    this.getSeachData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) this.getSeachData();
  }

  getSeachData = () => {
    const search = searchStringToParams( this.props.location.search, this.searchStatePropTypes );
    const pagingObject = searchStringToParams(this.props.location.search, pagingPropTypes);
    const paging = {...this.state.paging, ...pagingObject};
    this.setState({ search, paging }, this.loadItems)
  }

  doSearch = (searchParams) => {
    this.props.history.push( `/${this.collectionName}?`+objToQueryString(searchParams) );
  }

  handlePageChange = (page) => {
    const searchParams = this.state.search;
    const perPage = this.state.paging.perPage;
    this.props.history.push('/' + this.collectionName  + '?' + objToQueryString({
      ...searchParams,
      perPage,
      page,
    }));
  }

  removeItem = (item) => {
    const busyItems = this.state.busyItems;
    busyItems.push( item.id );
    this.setState( {busyItems} );

    item.delete().then((id) => {
      const items = this.state.items.filter((filteredItem) => filteredItem.id !== item.id);
      this.setState( {items} );
    }).catch(console.error).then(() => {
      const busyItems = this.state.busyItems.filter((id) => item.id !== id);
      this.setState( {busyItems} );
    });
  }

  loadItems = () => {
    if (!this.itemClass) {
      console.error("Please set list model class");
    }
    const searchParams = this.state.search;
    const {page, perPage} = this.state.paging;

    this.setState( {loading: true} );
    this.itemClass.query( {...searchParams, page, perPage} ).then( ({items, paging}) => {
      this.setState({ items, paging, loading: false});
    }).catch( (errors) => {
      this.setState({loading: false, errors});
    });
  }

  render() {
    const Item = this.Item;
    const SearchForm = this.SearchForm;
    const paging = this.state.paging;
    const paginating = <PaginatingWithInfo
          activePage={paging.page}
          itemsCountPerPage={paging.perPage}
          totalItemsCount={paging.total}
          pageRangeDisplayed={5}
          outerClass="col-xl-12 mt-3"
          infoClass="pagination-info col-4"
          innerClass="pagination col-8"
          itemClass="page-item"
          linkClass="page-link"
          onChange={this.handlePageChange}
        />;
    return (
      <div>
        <h2>{this.collectionNameHuman}</h2>
        {SearchForm && <SearchForm item={this.state.search} onSubmit={this.doSearch} />}
        {this.noAddAction ? null : <Link to={`/${this.collectionName}/add`} className="btn btn-primary mt-2 mb-2 ">Добавить</Link>}
        {paginating}
        <div className="col-xl-12">
          {this.state.items.map(item => <Item item={item} collectionName={this.collectionName} key={item.id} onRemove={this.removeItem}/>)}
        </div>
        {paginating}
      </div>
    );
  }
}
